import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { viewSuperAdminProfile } from '../../service/endpoints'; // Import your API call

export const Profilehandler = createAsyncThunk('Profilehandler', async () => {
    try {
        const response = await viewSuperAdminProfile();
        return response.data // Ensure you return the data correctly
    } catch (error) {
        throw error;
    }
});

const ProfileSlice = createSlice({
    name: 'view_profile',
    initialState: {
        response: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers:(builder)=>{
        builder.addCase(Profilehandler.fulfilled,(state,action)=>{
            state.isLoading = false;
            state.data= action.payload;
        });
        builder.addCase(Profilehandler.pending,(state,action)=>{
            state.isLoading = true
        });
        builder.addCase(Profilehandler.rejected,(state,action)=>{
            state.isError=true;
        });
    }
});

export default ProfileSlice.reducer;